import styled from "styled-components"
import BasicInfo from "./components/BasicInfo"
import JobInterest from "./components/JobInterest"
import JzButton from "@/components/JzButton"
import useResumeData from "@/pages/Mobile/hooks/useResumeData"
import { Module } from "@/common/module/module"
import EducationalBackground from "./components/EducationalBackground"
import WorkExperience from "./components/WorkExperience"
import SchoolExperience from "./components/SchoolExperience"
import ProjectExperience from "./components/ProjectExperience"
import InternshipExperience from "./components/InternshipExperience"
import { useNavigate } from "react-router-dom"
import useQueryParam from "@/hooks/useQueryParam"
import SingleField from "./components/SingleField"
import { useLayoutEffect, useMemo, useState } from "react"
import { isEmpty } from "lodash"
import Portfolio from "./components/Portfolio"
import usePreScroll from "../../hooks/usePreScroll"
import PcTip from "./components/PcTip"
import Navigator from "../../components/Navigator"
import { useSelector } from "react-redux"


const ResumeWrapStyled = styled.div`
    padding: 10px;
    background-color: #F7F8F9;
    min-height: calc(100vh);
    padding-bottom: 72px;
    .resume-wrap-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 8px 12px;
        padding-bottom: 24px;
        background-color: #FFFFFF;
    }
`

const moduleList = [
    {
        moduleName: Module.BASE,
        Component: BasicInfo
    },
    {
        moduleName: Module.JOB_INTEREST,
        Component: JobInterest
    },
    {
        moduleName: Module.EDUCATIONAL_BACKGROUND,
        Component: EducationalBackground
    },
    {
        moduleName: Module.WORK_EXPERIENCE,
        Component: WorkExperience
    },
    {
        moduleName: Module.CAMPUS_ACTIVITIES, // 校园活动
        Component: SchoolExperience
    },
    {
        moduleName: Module.PROJECT_EXPERIENCE, // 项目经历
        Component: ProjectExperience
    },
    {
        moduleName: Module.INTERNSHIP_EXPERIENCE, // 实习经历
        Component: InternshipExperience
    },
    {
        moduleName: Module.PORTFOLIO, // 作品展示
        Component: Portfolio
    },
    {
        moduleName: Module.SKILLS, // 技能特长
        Component: SingleField
    },
    {
        moduleName: Module.SELF_EVALUATION, // 自我评价
        Component: SingleField
    },
    {
        moduleName: Module.INTEREST, // 兴趣爱好
        Component: SingleField
    },
    {
        moduleName: Module.LANGUAGE_PROFICIENCY, // 语言能力
        Component: SingleField
    },
    {
        moduleName: Module.HONORS_AND_AWARDS, // 荣誉证书
        Component: SingleField
    },
]



const Resume = () => {
    const resumeId = useQueryParam('id')
    const navigate = useNavigate()
    const { data: resumeData, template } = useResumeData()
    const resumeName = useSelector(state => state.mobileEdit.data?.resume?.name)
    console.log('data', resumeName)
    const [visible, setVisible] = useState(true)
    usePreScroll()
    const visibleModuleList = useMemo(() => {
        if (!template || !template.moduleConfig) return moduleList
        const moduleConfig = template.moduleConfig
        let list = []
        if (!isEmpty(resumeData)) {
            const customModuleList = Object.keys(resumeData).filter((key) => {
                return resumeData[key].type === Module.CUSTOM_MODULE
            }).map(key => ({
                sort: resumeData[key].sort,
                customId: key,
                moduleName: Module.CUSTOM_MODULE,
                Component: SingleField
            }))
            list = moduleList.filter(item => moduleConfig[item.moduleName] && resumeData[item.moduleName]?.visible !== false).map(item => ({...item, sort: resumeData?.[item.moduleName]?.sort})).concat(customModuleList)
        } else {
            list = moduleList.filter(item => moduleConfig[item.moduleName]).map(item => ({...item, sort: resumeData?.[item.moduleName]?.sort}))
        }

        // 排序
        list.sort((a, b) => a.sort - b.sort)
        return list
    }, [template, resumeData])
    
    const handleClickModuleManage = () => {
        navigate(`/mobile/resume/module_manage?id=${resumeId}`)
    }

    const handleClickPreview = () => {
        navigate(`/mobile/resume/preview?id=${resumeId}`)
    }
    if (__DEV__) {
        console.log('resumeData', resumeData)
    }
    return <>
        <Navigator title={resumeName} />
        <ResumeWrapStyled>
            <PcTip visible={visible} onClose={() => setVisible(false)} />
            {
                visibleModuleList.map(moduleItem => {
                    const { moduleName, Component, customId } = moduleItem
                    let data = resumeData[moduleName]?.data
                    if (moduleName === Module.CUSTOM_MODULE) {
                        data = resumeData[customId]?.data
                    }

                    return <div key={moduleName} style={{ marginBottom: 8 }}>
                        <Component customId={customId} moduleName={moduleName} data={data} />
                    </div>
                })
            }

            <div className="resume-wrap-footer flex">
                <JzButton onClick={handleClickModuleManage} className="flex-1" style={{ marginRight: 8, backgroundColor: '#F3F4F5' }} >模块管理</JzButton>
                <JzButton onClick={handleClickPreview} className="flex-2" $type="primary">预览简历</JzButton>
            </div>
        </ResumeWrapStyled>
    </>
}

export default Resume